<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="4" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <b-col cols="12" sm="5" class="mt-2 mt-sm-0">
            <b-input-group>
              <b-form-input
                size="sm"
                v-model="root"
                placeholder="Find"
                list="paths"
              ></b-form-input>

              <datalist id="paths">
                <option v-for="path in options.folders" :key="path.key">
                  {{ path.id }}
                </option>
              </datalist>
              <b-input-group-append>
                <b-button
                  id="manualinvoice-refresh"
                  size="sm"
                  squared
                  variant="outline-primary"
                  @click="loadData()"
                >
                  <i class="fa fa-refresh"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <treeselect
              id="select-folder"
              :disabled="busyddl"
              :clearable="false"
              v-model="root"
              :options="options.folders"
            /> -->
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!find"
                        @click="find = ''"
                      >
                        <i v-if="find" class="fa fa-remove"></i>
                        <i v-if="!find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-tooltip target="manualinvoice-add" triggers="hover"
          >Click to add manual invoice</b-tooltip
        >
        <b-tooltip target="manualinvoice-refresh" triggers="hover"
          >Click to refresh table</b-tooltip
        >
      </b-card-header>

      <b-card-body class="px-0 pt-0">
        <b-table
          striped
          sticky-header="415px"
          fixed
          small
          bordered
          selectable
          select-mode="single"
          @row-selected="onRowSelected"
          :busy="busy"
          :fields="options.fields"
          :filter="find"
          :items="items"
          class="gridtable my-0"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner variant="primary" class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:empty="scope">
            <p v-if="scope" class="text-center mt-2 mb-0">
              {{ messagenofiles }}
            </p>
          </template>
          <template v-slot:cell(icon)="row">
            <i :class="row.item.icon" class="text-primary"></i>
          </template>
          <template v-slot:cell()="row">
            <div
              v-if="
                options.badges &&
                options.badges.find((obj) => obj.key == row.field.key)
              "
            >
              <span
                v-html="
                  $helpers.badgeField(
                    row.item,
                    options.badges.find((obj) => obj.key == row.field.key),
                    options
                  )
                "
              ></span>
            </div>
            <div v-else>{{ row.value }}</div>
          </template>
          <template v-if="options.actions" v-slot:cell(actions)="row">
            <div id="actions-container" v-if="options.actions_as_elipses">
              <b-button
                variant="link"
                size="sm"
                title="Actions"
                :id="'popover-target-' + row.item.id"
                @click="$root.$emit('bv::hide::popover')"
              >
                <i class="fa fa-ellipsis-h text-primary"></i>
              </b-button>
              <b-popover
                container="actions-container"
                triggers="click blur"
                placement="leftbottom"
                :target="'popover-target-' + row.item.id"
              >
                <div>
                  <b-nav vertical>
                    <b-nav-item
                      :title="action.label"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                    >
                      <b-row class="px-2">
                        <b-col class="px-0">
                          <span class="text-normal">{{ action.label }}</span>
                        </b-col>
                        <b-col cols="1">
                          <i :class="action.icon" class="text-primary"></i>
                        </b-col>
                      </b-row>
                    </b-nav-item>
                  </b-nav>
                </div>
              </b-popover>
            </div>
            <div v-else>
              <b-button
                variant="link"
                size="sm"
                v-for="action in $helpers.actionsValid(row.item, options)"
                :key="action.key"
                @click.stop="table_action(action.key, row)"
                :title="action.label"
              >
                <i :class="action.icon" class="text-primary"></i>
              </b-button>
            </div>
          </template>

          <template v-slot:row-details="row">
            <b-card>
              <component
                :is="options.component.name"
                :search="search"
                @discard="discard(row)"
              ></component>
            </b-card>
          </template>
        </b-table>

        <b-row class="excelsheetbuttons">
          <!-- <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="nlpost_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="nlpost_log" triggers="hover"
                >Show log</b-tooltip
              >
            </b-button-group>
          </b-col> -->
          <b-col class="text-right">
            <b-link
              id="nlpost-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="nlpost-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ count }} items(s)</span
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import * as fs from "file-saver";

function dynamicSort(property) {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
}


export default {
  name: "Filemanager",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      name: "File Explorer",
      find: null,
      id: "",
      typename: "",
      message: "",
      messagenofiles: "There are no files to show",
      items: [],
      file: "",
      modal: { action: "" },
      modalActive: false,
      fieldtypes: [],
      selected: [],
      uploading: false,
      filter: [],
      busy: false,
      busyddl: false,
      root: null,
      folder: null,
      count: 0,
      options: {
        title: "File Manager",
        icon: "fa fa-sitemap",
        debounce: 500,
        folders: [],
        fields: [
          {
            key: "icon",
            label: "",
            class: "w-20px mr-1",
          },
          {
            key: "name",
            label: "Name",
            sortable: true,
            class: "text-left",
          },
          {
            key: "type_of",
            label: "Type",
            sortable: true,
            class: "text-center w-80px d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Date",
            sortable: true,
            class: "text-center w-130px d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value * 0.001)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },

          {
            key: "size",
            label: "Size",
            sortable: true,
            class: "text-right w-80px d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$options.filters.formatSize(value);
              }
              return result;
            },
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-50px text-center",
          },
        ],
        badges: [
          {
            key: "type_of",
            type: "badge",
            other: "dark",
            "File folder": "warning",
            File: "info",
          },
        ],
        actions: [
          {
            key: "download",
            label: "Download",
            icon: "fa fa-cloud-download",
            single: true,
            multiple: false,
          },
          // {
          //   key: "download",
          //   label: "Download",
          //   icon: "fa fa-cloud-download text-info",
          //   single: true,
          //   multiple: false,
          // },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    this.$helpers.resizableColumns();

    this.loadDDL();
    this.loadData();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadData();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadData();
      },
    },
    root: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.folder = newVal;
          this.loadData();
        }
      },
    },
    folder: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    async loadDDL() {
      console.log("filemanager loadDDL");
      this.busyddl = true;

      let variables = {
        name: "accounts_folders",
      };

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query folder_ddl($name: String) {
              folder_ddl(name: $name) {
                id
                label
                children {
                  id
                  label
                  children {
                    id
                    label
                  }
                }
              }
            }
          `,
          variables,
        });
        console.log(response);

        this.options.folders = response.data.folder_ddl;
        this.options.folders.sort(dynamicSort('id'))
        console.log(this.options.folders)

        if (this.options.folders.length > 0) {
          this.root = this.options.folders[1].id;
        }
      } catch (error) {
        console.log(error);
      }
      this.busyddl = false;
    },
    async loadData() {
      this.busy = true;
      this.items = [];
      this.count = 0;
      let variables = {
        path: this.folder,
        deep: false,
        orderby: "updated_at|DESC",
      };

      console.log("file_explorer: ", variables);
      const response = await this.$apollo.query({
        query: gql`
          query file_explorer($path: String, $deep: Boolean, $orderby: String) {
            file_explorer(path: $path, deep: $deep, orderby: $orderby) {
              name: filename
              path
              size
              type_of
              path
              updated_at
              created_at
            }
          }
        `,
        variables,
      });
      if (response.data.file_explorer) {
        this.items = [...response.data.file_explorer];
        let folderup = "";
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].type_of == "File folder") {
            this.items[i].icon = "fa fa-folder-o text-warning";
          } else {
            this.items[i].icon = "fa " + this.setIcon(this.items[i].name);
          }
          folderup = this.items[i].path;
        }
        folderup = folderup.split("//").join("^^");
        folderup = folderup.split("/").slice(0, -1).join("/");
        folderup = folderup.split("^^").join("//");
        this.count = this.items.length;

        if (folderup != this.root) {
          folderup = folderup.split("//").join("^^");
          folderup = folderup.split("/").slice(0, -1).join("/");
          folderup = folderup.split("^^").join("//");
          this.items.unshift({
            icon: "fa fa-level-up",
            name: "[..]",
            path: folderup,
          });
        }
        this.busy = false;
      }
    },
    onRowSelected(row) {
      if (row) {
        if (row[0]) {
          console.log("row clicked", row);
          if (row[0].icon == "fa fa-level-up") {
            console.log("move up", row[0].path);
            this.folder = row[0].path;
          } else {
            console.log("move down", row[0].path);
            if (row[0].type_of == "File folder") {
              this.folder = row[0].path;
            }
          }
        }
      }
    },
    setIcon(filename) {
      let ext = filename.split(".").pop().toString().toLowerCase();
      switch (ext) {
        case "zip":
          return "fa-file-archive-o";
        case "pdf":
          return "fa-file-pdf-o";
        case "xls":
        case "xlsx":
          return "fa-file-excel-o";
        case "ppt":
        case "pptx":
          return "fa-file-powerpoint-o";
        case "doc":
        case "docx":
          return "fa-file-word-o";
        case "bmp":
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "tif":
        case "tiff":
          return "fa-file-image-o";
        case "mp4":
        case "mp3":
          return "fa-file-video-o";
        default:
          return "fa-file-text-o";
      }
    },
    onRowSelected(row) {
      if (row) {
        if (row[0]) {
          console.log("row clicked", row);
          if (row[0].icon == "fa fa-level-up") {
            console.log("move up", row[0].path);
            this.folder = row[0].path;
          } else {
            console.log("move down", row[0].path);
            if (row[0].type_of == "File folder") {
              this.folder = row[0].path;
            }
          }
        }
      }
    },
    changeView(e) {
      this.currentView = e;
      this.loadData(this.currentView);
    },
    Upload() {
      for (var i = 0; i < this.items.length; i++) {
        let file = this.items[i];
        if (file.name == this.file.name) {
          this.uploadmessage =
            "You have already uploaded this file, please choose another.";
          return;
        }
      }

      let variables = {
        file: this.file,
        email: this.user.email,
      };
      console.log("upload", variables);
      this.uploading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ($email: String, $file: Upload!) {
              singleUpload(email: $email, file: $file) {
                id
                filename
              }
            }
          `,
          variables,
        })
        .then((uploaded) => {
          console.log("upload mutation", uploaded);
          if (uploaded) {
            this.Link(uploaded.data.singleUpload.id);
          }
          this.file = "";
          this.uploading = false;
          this.uploadmessage = "";
          this.showupload = false;
        })
        .catch((err) => {
          this.message = err;
          console.error(err);
        });
    },

    visibleActions(action, item) {
      console.log("action=", action, "item=", item);
      if (item.icon == "fa fa-level-up") {
        return false;
      }
      if (action.key == "download" && item.type_of == "File folder") {
        return false;
      }
      return true;
    },
    async table_action(key, row) {
      this.$root.$emit("bv::hide::popover");
      console.log("you have clicked: ", key, row);

      for (var i = 0; i < this.options.actions.length; i++) {
        if (this.options.actions[i].key == key) {
          if (this.options.actions[i].hasOwnProperty("modal")) {
            // this.selected = !Array.isArray(sender) ? [sender.item] : sender;
            // this.modal = this.actions[i].modal;
            // this.modalActive = true;
            console.log(this.options.modal);
            return;
          }
          if (this.options.actions[i].hasOwnProperty("component")) {
            this.options.component = this.options.actions[i].component;
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            row.toggleDetails();
            return;
          }
          if (this.options.actions[i].hasOwnProperty("overlay")) {
            if (this.options.actions[i].overlay.message) {
              let message = this.options.actions[i].overlay.message;
              for (var prop in row.item) {
                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                  message = message
                    .split("%" + prop + "%")
                    .join(row.item[prop]);
                }
              }
              this.options.overlay.message = message;
            }
            if (this.options.actions[i].overlay.buttons) {
              this.options.overlay.buttons =
                this.options.actions[i].overlay.buttons;
            }
            this.options.overlay_show = !this.options.overlay_show;
            return;
          }
        }
      }

      switch (key) {
        case "download":
          this.download(row.item);
          break;
      }
    },
    discard() {
      this.$emit("discard");
    },

    async loadFile(a) {
      let result = null;
      this.busy = true;
      let variables = {
        path: a,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_download64($path: String) {
              file_download64(path: $path)
            }
          `,
          variables,
        });
        result = response.data.file_download64;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      return result;
    },
    async download(a) {
      console.log("download()", a.path);
      let contents = await this.loadFile(a.path);
      var byteCharacters = atob(contents);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], { type: "application/xml" });
      fs.saveAs(blob, a.name);
    },
  },
  computed: {
    ...mapGetters(["loading", "error", "user"]),
  },
};
</script>

<style>
</style>
